import { Injectable } from '@angular/core';
import { SESSION_STORAGE_KEYS } from '../common/session-storage-keys';
import { SortDirection } from '@angular/material/sort/sort-direction';

@Injectable({
                providedIn: 'root'
            })
export class ConnectHomeListService {
    private _searchText : string;
    private _sortColumn : string;
    private _sortOrder : SortDirection;

    get searchText(){
        return this._searchText;
    }

    get sortColumn(){
        return this._sortColumn;
    }

    get sortOrder(){
        return this._sortOrder;
    }

    set searchText(searchText :string) {
        this._searchText = searchText;
    }

    set sortColumn(sortColumn :string) {
        this. _sortColumn = sortColumn;
    }

    set sortOrder(sortOrder :SortDirection) {
        this._sortOrder = sortOrder;
    }
}